export default "__VITE_ASSET__CBTvrODW__"